import { createGlobalStyle } from "styled-components"

const GlobalStyles: any = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-size: 16px;
    font-family: "Noto Sans JP", serif;
  }

  button {
    cursor: pointer;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
`

export { GlobalStyles }
